var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "setting-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-gear-2",
    d: "M24,14.187V9.813c-2.148-.766-2.726-.8-3.027-1.529s.083-1.169,1.059-3.223L18.939,1.968c-2.026.963-2.488,1.364-3.224,1.059S14.947,2.138,14.188,0H9.813c-.764,2.144-.8,2.725-1.529,3.027-.752.313-1.2-.1-3.223-1.059L1.968,5.061C2.945,7.116,3.33,7.554,3.027,8.285S2.146,9.049,0,9.813v4.375c2.139.76,2.725.8,3.027,1.528s-.081,1.167-1.059,3.223l3.093,3.093c2-.95,2.47-1.373,3.223-1.059.728.3.764.88,1.529,3.027h4.374c.758-2.131.8-2.723,1.537-3.031s1.186.1,3.215,1.062l3.093-3.093c-.975-2.05-1.362-2.492-1.059-3.223S21.853,14.952,24,14.187Zm-4.875.764c-.577,1.394-.068,2.458.488,3.578l-1.084,1.084c-1.093-.543-2.161-1.076-3.573-.49-1.4.581-1.79,1.693-2.188,2.877H11.234c-.4-1.185-.791-2.3-2.183-2.875a3.969,3.969,0,0,0-3.579.488L4.389,18.529c.557-1.118,1.066-2.18.487-3.58S3.185,13.165,2,12.767V11.234c1.185-.4,2.3-.791,2.875-2.184s.068-2.459-.488-3.579L5.471,4.387a3.958,3.958,0,0,0,3.58.488C10.443,4.3,10.836,3.185,11.234,2h1.534c.4,1.185.792,2.3,2.184,2.875a3.969,3.969,0,0,0,3.579-.488l1.084,1.084c-.556,1.121-1.065,2.187-.488,3.58S20.816,10.835,22,11.234v1.534c-1.188.4-2.3.791-2.877,2.183ZM12,9a3,3,0,1,1-3,3A3,3,0,0,1,12,9Zm0-2a5,5,0,1,0,5,5A5,5,0,0,0,12,7Z",
    transform: "translate(0 0)",
    fill: "#7bc807"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/setting-icon.bc941328.svg";
export { ForwardRef as ReactComponent };